import { render, staticRenderFns } from "./ViewFeedBack.vue?vue&type=template&id=276d0429&"
import script from "./ViewFeedBack.vue?vue&type=script&lang=js&"
export * from "./ViewFeedBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports